import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
// this folder need to delete if not used
@Component({
  selector: 'app-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class HeaderBarComponent {
  @Input() welcomeText: string = 'Welcome';
  @Input() subText: string = 'Have a nice day at work';
  @Input() showToggle: boolean = false;
  @Input() isActiveOutlet: boolean = false;
  @Input() bucketurl: string = '';
  @Output() isActiveOutletChange = new EventEmitter<boolean>();
  @Output() outletToggle = new EventEmitter<any>();
  @Input() showDateRange: boolean = true;
  @Output() openDateRangePicker = new EventEmitter<void>();

  onToggle(event: any) {
    this.isActiveOutletChange.emit(event.target.checked);
    this.outletToggle.emit(event);
  }

  onOpenDateRangePicker() {
    this.openDateRangePicker.emit();
  }
}
